import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import './landing.css';
// @ts-ignore
import { initLanding } from './landing';
import { AcMediaPlayer } from '../../components/security/AcMediaPlayer';
import { AcShieldLogo } from '../../components/security/AcShieldLogo';
import { useAuthStore } from '../../store/authStore';

export function LandingPage() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const [navOpen, setNavOpen] = useState(false);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [assunto, setAssunto] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState(''); // Honeypot bot trap
  const [numA, setNumA] = useState(0);
  const [numB, setNumB] = useState(0);
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const closeNav = useCallback(() => setNavOpen(false), []);

  const regenerateCaptcha = useCallback(() => {
    setNumA(Math.floor(Math.random() * 10) + 1);
    setNumB(Math.floor(Math.random() * 10) + 1);
    setCaptchaAnswer('');
  }, []);

  useEffect(() => {
    regenerateCaptcha();
  }, [regenerateCaptcha]);

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);

    const API = import.meta.env.VITE_API_URL || '/api/v1';

    try {
      const res = await fetch(`${API}/auth/fale-conosco`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nome,
          email,
          assunto,
          mensagem,
          website_url: websiteUrl,
          captcha_pergunta: `${numA} + ${numB}`,
          captcha_resposta: captchaAnswer,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Erro ao enviar a mensagem.');
      }

      toast.success('Mensagem enviada com sucesso! Agradecemos o contato.');
      setNome('');
      setEmail('');
      setAssunto('');
      setMensagem('');
      setWebsiteUrl('');
      setCaptchaAnswer('');
      regenerateCaptcha();
    } catch (err: any) {
      toast.error(err.message || 'Erro de conexão com o servidor.');
      regenerateCaptcha();
    } finally {
      setSubmitting(false);
    }
  };

  useLayoutEffect(() => {
    let cancelled = false;

    const runInit = () => {
      if (!cancelled) initLanding();
    };

    if ((window as Window & { lucide?: { createIcons: () => void } }).lucide) {
      runInit();
      return () => { cancelled = true; };
    }

    const existing = document.querySelector<HTMLScriptElement>('script[data-landing-lucide]');
    if (existing) {
      if (existing.dataset.loaded === 'true') runInit();
      else existing.addEventListener('load', runInit, { once: true });
      return () => { cancelled = true; };
    }

    const script = document.createElement('script');
    script.src = 'https://unpkg.com/lucide@latest/dist/umd/lucide.js';
    script.dataset.landingLucide = 'true';
    script.onload = () => {
      script.dataset.loaded = 'true';
      runInit();
    };
    document.body.appendChild(script);

    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    document.body.style.overflow = navOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [navOpen]);

  return (
    <div className="landing-page font-sans antialiased text-gray-900 bg-white h-screen overflow-y-auto w-full relative">
      
    
    
    
    {navOpen && (
      <button
        type="button"
        className="nav-mobile-backdrop visible"
        aria-label="Fechar menu"
        onClick={closeNav}
      />
    )}

    <nav className="navbar" id="navbar">
        <div className="navbar-container">
            <a href="#hero" className="navbar-logo" style={{ display: 'flex', alignItems: 'center', gap: '8px' }} onClick={closeNav}>
                <div className="logo-icon" style={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <AcShieldLogo style={{ width: '100%', height: '100%' }} />
                </div>
                <span className="logo-text">Aluno <strong>Conectado</strong></span>
            </a>
            <ul className={`navbar-menu${navOpen ? ' active' : ''}`} id="navMenu">
                 <li><Link to="/sobre" className="nav-link" onClick={closeNav}>Sobre</Link></li>
                 <li><Link to="/politica-de-privacidade" className="nav-link" onClick={closeNav}>Privacidade</Link></li>
                 <li><a href="#pilares" className="nav-link" onClick={closeNav}>Pilares</a></li>
                 <li><a href="#funcionalidades" className="nav-link" onClick={closeNav}>Funcionalidades</a></li>
                 <li><a href="#impacto" className="nav-link" onClick={closeNav}>Impacto</a></li>

                <li><a href="#contato" className="nav-link nav-link-cta" onClick={closeNav}>Fale Conosco</a></li>
                <li><Link to="/login" className="nav-link nav-link-login" onClick={closeNav}>Entrar</Link></li>
            </ul>
            <button
              type="button"
              className={`navbar-toggle${navOpen ? ' active' : ''}`}
              id="navToggle"
              aria-label={navOpen ? 'Fechar menu' : 'Abrir menu'}
              aria-expanded={navOpen}
              onClick={() => setNavOpen((open) => !open)}
            >
                <span></span><span></span><span></span>
            </button>
        </div>
    </nav>

    
    
    

    <section className="hero" id="hero" style={{ 
      position: 'relative', 
      minHeight: '100vh', 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden'
    }}>
        {/* Fundo — imagem full-screen limpa */}
        <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
            <picture>
                <source media="(max-width: 768px)" srcSet="/assets/images/hero-mobile.webp" type="image/webp" />
                <source media="(min-width: 769px)" srcSet="/assets/images/hero.webp" type="image/webp" />
                <img src="/assets/images/hero.png" alt="Crianças em escola moderna" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </picture>
            {/* Overlay escuro suave para legibilidade */}
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(2,6,23,0.88) 0%, rgba(2,6,23,0.5) 35%, rgba(2,6,23,0.25) 60%, rgba(2,6,23,0.15) 100%)' }}></div>
        </div>
        
        <div className="hero-particles" id="heroParticles" style={{ zIndex: 1 }}></div>
        
        {/* Conteúdo centralizado */}
        <div style={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '0 24px', maxWidth: 800 }}>
            <div className="hero-badge" data-animate="fade-up" style={{ margin: '0 0 24px 0' }}>
                <i data-lucide="sparkles"></i>
                <span>Inovação na Educação Pública</span>
            </div>
            
            <h1 className="hero-title" data-animate="fade-up" data-delay="100" style={{ margin: 0, fontSize: 'clamp(3rem, 6vw, 5.5rem)', lineHeight: 1.05, textShadow: '0 4px 40px rgba(0,0,0,0.4)' }}>
                Aluno <span className="hero-title-accent">Conectado</span>
            </h1>
            
            <p className="hero-subtitle" data-animate="fade-up" data-delay="200" style={{ margin: '20px 0 0 0', maxWidth: 640, fontSize: '1.12rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.8, textShadow: '0 2px 16px rgba(0,0,0,0.5)' }}>
                Uma plataforma digital que reconecta escolas, famílias e alunos — 
                transformando a gestão educacional e protegendo nossas crianças 
                com tecnologia de ponta e segurança inteligente.
            </p>
            
            <div className="hero-actions" data-animate="fade-up" data-delay="300" style={{ margin: '32px 0 0 0', justifyContent: 'center' }}>
                <a href="#pilares" className="btn btn-primary btn-lg" style={{ background: '#7c3aed', borderColor: '#7c3aed' }}>
                    <span>Conheça o Programa</span>
                    <i data-lucide="arrow-down-circle"></i>
                </a>
                <a href="#contato" className="btn btn-outline btn-lg" style={{ color: '#ffffff', borderColor: 'rgba(255,255,255,0.3)' }}>
                    <span>Fale Conosco</span>
                </a>
                <Link to="/login" className="btn btn-outline btn-lg hero-login-btn" style={{ color: '#ffffff', borderColor: 'rgba(255,255,255,0.5)' }}>
                    <span>Entrar</span>
                </Link>
            </div>
        </div>
        
        {/* Live notification carousel — left side, vertically centered */}
        <div className="hero-notif-carousel" id="heroNotifCarousel">
        </div>

        {/* Scroll indicator */}
        <div className="hero-scroll-indicator" style={{ bottom: 24 }}>
            <div className="scroll-line"></div>
            <span>Scroll</span>
        </div>
    </section>

    {/* ═══ Seção Números — Fundo claro ═══ */}
    <section id="numeros" style={{ background: 'var(--white)', padding: '64px 0', position: 'relative' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
            {/* Card 1 */}
            <div data-animate="fade-up" data-delay="100" className="landing-stat-card" style={{
              background: 'var(--gray-50)', border: '1px solid var(--gray-100)',
              borderRadius: 20, padding: '36px 24px', textAlign: 'center',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease'
            }}>
                <div style={{ width: 52, height: 52, borderRadius: 16, background: 'rgba(27,54,93,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                    <i data-lucide="layers" style={{ width: 26, height: 26, color: 'var(--navy)' }}></i>
                </div>
                <span style={{ fontSize: '2.8rem', fontWeight: 700, color: 'var(--navy)', display: 'block', lineHeight: 1, fontFamily: 'var(--font-body)' }}>6</span>
                <span style={{ fontSize: '0.85rem', color: 'var(--gray-500)', marginTop: 8, display: 'block', fontWeight: 500 }}>Pilares Estratégicos</span>
            </div>
            {/* Card 2 */}
            <div data-animate="fade-up" data-delay="200" className="landing-stat-card" style={{
              background: 'var(--gray-50)', border: '1px solid var(--gray-100)',
              borderRadius: 20, padding: '36px 24px', textAlign: 'center',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease'
            }}>
                <div style={{ width: 52, height: 52, borderRadius: 16, background: 'rgba(139,168,136,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                    <i data-lucide="school" style={{ width: 26, height: 26, color: 'var(--sage-dark)' }}></i>
                </div>
                <span style={{ fontSize: '2.8rem', fontWeight: 700, color: 'var(--navy)', display: 'block', lineHeight: 1, fontFamily: 'var(--font-body)' }}>100+</span>
                <span style={{ fontSize: '0.85rem', color: 'var(--gray-500)', marginTop: 8, display: 'block', fontWeight: 500 }}>Escolas Projetadas</span>
            </div>
            {/* Card 3 */}
            <div data-animate="fade-up" data-delay="300" className="landing-stat-card" style={{
              background: 'var(--gray-50)', border: '1px solid var(--gray-100)',
              borderRadius: 20, padding: '36px 24px', textAlign: 'center',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease'
            }}>
                <div style={{ width: 52, height: 52, borderRadius: 16, background: 'rgba(184,107,71,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                    <i data-lucide="users" style={{ width: 26, height: 26, color: 'var(--terracotta)' }}></i>
                </div>
                <span style={{ fontSize: '2.8rem', fontWeight: 700, color: 'var(--navy)', display: 'block', lineHeight: 1, fontFamily: 'var(--font-body)' }}>300k+</span>
                <span style={{ fontSize: '0.85rem', color: 'var(--gray-500)', marginTop: 8, display: 'block', fontWeight: 500 }}>Pessoas Impactadas</span>
            </div>
        </div>
    </section>

    {/* ═══ Seção AC TV — Fundo claro ═══ */}
    <section className="section" id="destaque" style={{ background: 'var(--cream)', padding: '80px 0 100px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px' }}>
            
            {/* Header */}
            <div data-animate="fade-up" style={{ textAlign: 'center', marginBottom: 56 }}>
                <span style={{ display: 'inline-block', background: 'rgba(27,54,93,0.06)', border: '1px solid rgba(27,54,93,0.12)', padding: '6px 18px', borderRadius: 50, fontSize: '0.78rem', fontWeight: 600, color: 'var(--navy)', letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: 20 }}>AC TV — Canal Educacional</span>
                <h2 style={{ color: 'var(--navy)', fontSize: 'clamp(1.8rem, 3.5vw, 2.6rem)', lineHeight: 1.2, margin: '0 0 16px 0', fontWeight: 700, fontFamily: 'var(--font-body)' }}>
                    Conteúdo inteligente direto na <em style={{ color: 'var(--terracotta)', fontStyle: 'normal' }}>tela da escola</em>
                </h2>
                <p style={{ color: 'var(--gray-500)', fontSize: '1.05rem', maxWidth: 560, margin: '0 auto', lineHeight: 1.7 }}>
                    Comunicados oficiais, notícias do MEC, campanhas e alertas — 
                    tudo em um só canal, gerenciado pela plataforma.
                </p>
            </div>

            {/* Layout: Features + Phone */}
            <div data-animate="fade-up" data-delay="200" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 56, justifyContent: 'center' }}>
                
                {/* Features */}
                <div style={{ flex: '1 1 340px', maxWidth: 480, display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, padding: '18px 20px', background: 'var(--white)', borderRadius: 16, border: '1px solid var(--gray-100)', boxShadow: 'var(--shadow-sm)', transition: 'all 0.3s ease' }} className="landing-stat-card">
                        <div style={{ width: 44, height: 44, borderRadius: 14, background: 'rgba(27,54,93,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <i data-lucide="newspaper" style={{ width: 22, height: 22, color: 'var(--navy)' }}></i>
                        </div>
                        <div>
                            <div style={{ color: 'var(--navy)', fontSize: '0.98rem', fontWeight: 600, marginBottom: 4 }}>Notícias em Tempo Real</div>
                            <div style={{ color: 'var(--gray-500)', fontSize: '0.88rem', lineHeight: 1.5 }}>Repasses do MEC, editais e novidades direto na tela do hall.</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, padding: '18px 20px', background: 'var(--white)', borderRadius: 16, border: '1px solid var(--gray-100)', boxShadow: 'var(--shadow-sm)', transition: 'all 0.3s ease' }} className="landing-stat-card">
                        <div style={{ width: 44, height: 44, borderRadius: 14, background: 'rgba(184,107,71,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <i data-lucide="megaphone" style={{ width: 22, height: 22, color: 'var(--terracotta)' }}></i>
                        </div>
                        <div>
                            <div style={{ color: 'var(--navy)', fontSize: '0.98rem', fontWeight: 600, marginBottom: 4 }}>Campanhas Patrocinadas</div>
                            <div style={{ color: 'var(--gray-500)', fontSize: '0.88rem', lineHeight: 1.5 }}>Editoras, feiras e eventos com espaço para a comunidade.</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, padding: '18px 20px', background: 'var(--white)', borderRadius: 16, border: '1px solid var(--gray-100)', boxShadow: 'var(--shadow-sm)', transition: 'all 0.3s ease' }} className="landing-stat-card">
                        <div style={{ width: 44, height: 44, borderRadius: 14, background: 'rgba(139,168,136,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <i data-lucide="vote" style={{ width: 22, height: 22, color: 'var(--sage-dark)' }}></i>
                        </div>
                        <div>
                            <div style={{ color: 'var(--navy)', fontSize: '0.98rem', fontWeight: 600, marginBottom: 4 }}>Enquetes e Comunicados</div>
                            <div style={{ color: 'var(--gray-500)', fontSize: '0.88rem', lineHeight: 1.5 }}>Consultas à comunidade e comunicados oficiais.</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, padding: '18px 20px', background: 'var(--white)', borderRadius: 16, border: '1px solid var(--gray-100)', boxShadow: 'var(--shadow-sm)', transition: 'all 0.3s ease' }} className="landing-stat-card">
                        <div style={{ width: 44, height: 44, borderRadius: 14, background: 'rgba(59,130,246,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <i data-lucide="shield-check" style={{ width: 22, height: 22, color: '#3B82F6' }}></i>
                        </div>
                        <div>
                            <div style={{ color: 'var(--navy)', fontSize: '0.98rem', fontWeight: 600, marginBottom: 4 }}>Custo Zero para a Escola</div>
                            <div style={{ color: 'var(--gray-500)', fontSize: '0.88rem', lineHeight: 1.5 }}>Infraestrutura mantida pela plataforma sem taxas.</div>
                        </div>
                    </div>
                </div>

                {/* Phone mockup */}
                <div style={{ flex: '0 0 auto', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ 
                      width: 300, 
                      height: 560, 
                      borderRadius: 28, 
                      overflow: 'hidden', 
                      boxShadow: '0 25px 50px -12px rgba(27,54,93,0.25), 0 0 0 8px var(--white), 0 0 0 9px var(--gray-200)',
                      background: '#111',
                      animation: 'acm-fadeIn 1s ease 0.5s both'
                    }}>
                        <AcMediaPlayer mode="compact" readonly={true} />
                    </div>
                </div>

            </div>
        </div>
    </section>

    
    
    
    <section className="section section-about" id="sobre">
        <div className="container">
            <div className="section-header" data-animate="fade-up">
                <span className="section-tag">O Cenário Atual</span>
                <h2 className="section-title">Por que precisamos agir <em>agora</em>?</h2>
                <p className="section-description">
                    A educação pública brasileira enfrenta desafios que transcendem os muros da sala de aula.
                    Dados alarmantes exigem uma resposta imediata e inovadora.
                </p>
            </div>
            <div className="stats-grid">
                <div className="stat-card stat-card-danger" data-animate="fade-up" data-delay="100">
                    <div className="stat-card-icon">
                        <i data-lucide="alert-triangle"></i>
                    </div>
                    <div className="stat-card-number">6/10</div>
                    <h3 className="stat-card-title">A Epidemia da Violência</h3>
                    <p className="stat-card-text">
                        6 em cada 10 ataques a escolas nos últimos 20 anos ocorreram 
                        apenas entre 2022 e 2023. O clima é de medo e insegurança.
                    </p>
                </div>
                <div className="stat-card stat-card-warning" data-animate="fade-up" data-delay="200">
                    <div className="stat-card-icon">
                        <i data-lucide="users-round"></i>
                    </div>
                    <div className="stat-card-number">1 Milhão</div>
                    <h3 className="stat-card-title">O Abismo Família-Escola</h3>
                    <p className="stat-card-text">
                        Queda de mais de 1 milhão de matrículas em 2025. 
                        Apenas 12% dos pais participam ativamente da rotina escolar.
                    </p>
                </div>
                <div className="stat-card stat-card-info" data-animate="fade-up" data-delay="300">
                    <div className="stat-card-icon">
                        <i data-lucide="wifi-off"></i>
                    </div>
                    <div className="stat-card-number">62,1%</div>
                    <h3 className="stat-card-title">O Atraso Tecnológico</h3>
                    <p className="stat-card-text">
                        Apenas 62,1% das escolas públicas possuem internet para 
                        aprendizado. A gestão ainda é sufocada por burocracia analógica.
                    </p>
                </div>
            </div>
        </div>
    </section>

    
    
    
    <section className="section section-solution" id="solucao">
        <div className="container">
            <div className="solution-grid">
                <div className="solution-visual" data-animate="fade-right">
                    <div className="ecosystem-diagram">
                        <div className="eco-center">
                            <i data-lucide="laptop-minimal"></i>
                            <span>Plataforma<br />Digital</span>
                        </div>
                        <div className="eco-orbit">
                            <div className="eco-node eco-node-familia">
                                <i data-lucide="home"></i>
                                <span>Família</span>
                            </div>
                            <div className="eco-node eco-node-escola">
                                <i data-lucide="school"></i>
                                <span>Escola</span>
                            </div>
                            <div className="eco-node eco-node-aluno">
                                <i data-lucide="graduation-cap"></i>
                                <span>Aluno</span>
                            </div>
                        </div>
                        <svg className="eco-lines" viewBox="0 0 400 400">
                            <circle cx="200" cy="200" r="150" fill="none" stroke="rgba(139,168,136,0.3)" strokeWidth="1" strokeDasharray="8 4"/>
                            <circle cx="200" cy="200" r="100" fill="none" stroke="rgba(27,54,93,0.15)" strokeWidth="1" strokeDasharray="4 4"/>
                        </svg>
                    </div>
                </div>
                <div className="solution-content" data-animate="fade-left">
                    <span className="section-tag">A Resolução</span>
                    <h2 className="section-title">Tecnologia a favor<br />da <em>comunidade</em></h2>
                    <p className="solution-description">
                        O Programa <strong>Aluno Conectado</strong> é a primeira política pública que 
                        unifica <strong>segurança física</strong>, <strong>participação ativa</strong> 
                        e <strong>eficiência de gestão</strong> em um único ambiente digital.
                    </p>
                    <ul className="solution-features">
                        <li>
                            <i data-lucide="shield-check"></i>
                            <span>Proteção em tempo real para os alunos</span>
                        </li>
                        <li>
                            <i data-lucide="message-circle-heart"></i>
                            <span>Fim do distanciamento entre pais e professores</span>
                        </li>
                        <li>
                            <i data-lucide="bar-chart-3"></i>
                            <span>Gestão baseada em dados, não em papel</span>
                        </li>
                        <li>
                            <i data-lucide="brain-circuit"></i>
                            <span>Inteligência artificial para prevenção da evasão</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    
    
    
    <section className="section section-pillars" id="pilares">
        <div className="container">
            <div className="section-header" data-animate="fade-up">
                <span className="section-tag">Estrutura do Programa</span>
                <h2 className="section-title">Os 6 Pilares do <em>Ecossistema Escolar</em></h2>
                <p className="section-description">
                    Uma abordagem integrada que cobre todas as dimensões da experiência educacional.
                </p>
            </div>
            <div className="pillars-grid">
                <div className="pillar-card" data-animate="fade-up" data-delay="50" data-color="navy">
                    <div className="pillar-number">01</div>
                    <div className="pillar-icon"><i data-lucide="shield-check"></i></div>
                    <h3>Segurança Escolar Inteligente</h3>
                    <p>Controle de acesso por reconhecimento facial, QR Code e cartão digital. Alertas de entrada, saída e transporte em tempo real.</p>
                </div>
                <div className="pillar-card" data-animate="fade-up" data-delay="100" data-color="sage">
                    <div className="pillar-number">02</div>
                    <div className="pillar-icon"><i data-lucide="smartphone"></i></div>
                    <h3>Comunicação Digital</h3>
                    <p>Canal direto e instantâneo entre escola e família. Avisos, reuniões, eventos e alertas emergenciais na palma da mão.</p>
                </div>
                <div className="pillar-card" data-animate="fade-up" data-delay="150" data-color="terracotta">
                    <div className="pillar-number">03</div>
                    <div className="pillar-icon"><i data-lucide="clipboard-list"></i></div>
                    <h3>Gestão Integrada</h3>
                    <p>Digitalização de faltas, agenda escolar, conteúdo das aulas e perfil profissional dos professores. Fim da burocracia analógica.</p>
                </div>
                <div className="pillar-card" data-animate="fade-up" data-delay="200" data-color="blue">
                    <div className="pillar-number">04</div>
                    <div className="pillar-icon"><i data-lucide="bar-chart-3"></i></div>
                    <h3>Inteligência Educacional</h3>
                    <p>Painéis estratégicos com índices de presença, padrões de faltas e identificação de alunos em risco de evasão escolar.</p>
                </div>
                <div className="pillar-card" data-animate="fade-up" data-delay="250" data-color="warm">
                    <div className="pillar-number">05</div>
                    <div className="pillar-icon"><i data-lucide="heart-handshake"></i></div>
                    <h3>Apoio Social</h3>
                    <p>Plataforma solidária para doação e troca de uniformes e materiais escolares entre as famílias da comunidade.</p>
                </div>
                <div className="pillar-card" data-animate="fade-up" data-delay="300" data-color="gray">
                    <div className="pillar-number">06</div>
                    <div className="pillar-icon"><i data-lucide="server"></i></div>
                    <h3>Infraestrutura Tecnológica</h3>
                    <p>Equipamentos, conectividade e treinamento para professores e gestores. Sustentabilidade e escalabilidade do programa.</p>
                </div>
            </div>
        </div>
    </section>

    
    
    
    <section className="section section-features" id="funcionalidades">
        <div className="container">
            <div className="section-header" data-animate="fade-up">
                <span className="section-tag">Na Prática</span>
                <h2 className="section-title">Como funciona no <em>dia a dia</em></h2>
            </div>
            <div className="features-showcase">
                
                <div className="feature-row" data-animate="fade-up">
                    <div className="feature-mockup">
                        <div className="phone-frame">
                            <div className="phone-screen">
                                <div className="phone-notif">
                                    <div className="notif-icon notif-green"><i data-lucide="check-circle"></i></div>
                                    <div className="notif-content">
                                        <strong>Escola Municipal Silva</strong>
                                        <p>Seu filho <strong>Pedro</strong> entrou na escola às <strong>07:10</strong></p>
                                    </div>
                                    <span className="notif-time">agora</span>
                                </div>
                                <div className="phone-notif">
                                    <div className="notif-icon notif-blue"><i data-lucide="bus"></i></div>
                                    <div className="notif-content">
                                        <strong>Transporte Escolar</strong>
                                        <p>Embarque no transporte escolar <strong>confirmado</strong></p>
                                    </div>
                                    <span className="notif-time">06:45</span>
                                </div>
                                <div className="phone-notif">
                                    <div className="notif-icon notif-terracotta"><i data-lucide="log-out"></i></div>
                                    <div className="notif-content">
                                        <strong>Saída Registrada</strong>
                                        <p>Pedro saiu da escola às <strong>12:05</strong></p>
                                    </div>
                                    <span className="notif-time">ontem</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feature-info">
                        <div className="feature-tag">Pilar 1</div>
                        <h3>Segurança em Tempo Real</h3>
                        <p>Os pais recebem notificações automáticas quando seus filhos entram e saem da escola. 
                        O sistema utiliza reconhecimento facial, QR Code ou cartão digital para registrar os acessos, 
                        trazendo paz de espírito para as famílias.</p>
                        <ul className="feature-list">
                            <li><i data-lucide="check"></i> Notificação automática de entrada e saída</li>
                            <li><i data-lucide="check"></i> Confirmação de saída de casa pelo app</li>
                            <li><i data-lucide="check"></i> Monitoramento do transporte escolar</li>
                            <li><i data-lucide="check"></i> Alerta se o aluno não chegar à escola</li>
                        </ul>
                    </div>
                </div>

                
                <div className="feature-row feature-row-reverse" data-animate="fade-up">
                    <div className="feature-mockup">
                        <div className="phone-frame">
                            <div className="phone-screen phone-screen-agenda">
                                <div className="app-header-mock">
                                    <h4>📚 Agenda Semanal</h4>
                                </div>
                                <div className="agenda-day">
                                    <div className="agenda-day-name">Segunda-feira</div>
                                    <div className="agenda-subjects">
                                        <span className="subject-pill subject-math">Matemática</span>
                                        <span className="subject-pill subject-port">Português</span>
                                        <span className="subject-pill subject-edfis">Ed. Física</span>
                                        <span className="subject-pill subject-hist">História</span>
                                    </div>
                                    <div className="agenda-content">
                                        <small><strong>Matemática:</strong> Frações equivalentes</small>
                                        <small><strong>Português:</strong> Interpretação de texto</small>
                                    </div>
                                </div>
                                <div className="agenda-day">
                                    <div className="agenda-day-name">Terça-feira</div>
                                    <div className="agenda-subjects">
                                        <span className="subject-pill subject-geo">Geografia</span>
                                        <span className="subject-pill subject-sci">Ciências</span>
                                        <span className="subject-pill subject-math">Matemática</span>
                                        <span className="subject-pill subject-art">Artes</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feature-info">
                        <div className="feature-tag">Pilares 2 & 3</div>
                        <h3>Comunicação e Gestão Digital</h3>
                        <p>A escola envia avisos, eventos e comunicados diretamente para o celular dos responsáveis. 
                        Os pais acompanham a agenda semanal, o conteúdo ministrado em cada aula e podem justificar 
                        faltas sem sair de casa.</p>
                        <ul className="feature-list">
                            <li><i data-lucide="check"></i> Agenda escolar digital acessível</li>
                            <li><i data-lucide="check"></i> Conteúdo das aulas em tempo real</li>
                            <li><i data-lucide="check"></i> Justificativa de faltas pelo app</li>
                            <li><i data-lucide="check"></i> Avisos e alertas emergenciais</li>
                        </ul>
                    </div>
                </div>

                
                <div className="feature-row" data-animate="fade-up">
                    <div className="feature-mockup">
                        <div className="dashboard-frame">
                            <div className="dash-header">
                                <span className="dash-dot"></span>
                                <span className="dash-dot"></span>
                                <span className="dash-dot"></span>
                                <span className="dash-title">Dashboard — Escola Municipal</span>
                            </div>
                            <div className="dash-content">
                                <div className="dash-kpi">
                                    <div className="kpi-card">
                                        <span className="kpi-value">94,2%</span>
                                        <span className="kpi-label">Frequência</span>
                                    </div>
                                    <div className="kpi-card kpi-warning">
                                        <span className="kpi-value">12</span>
                                        <span className="kpi-label">Alunos em Risco</span>
                                    </div>
                                    <div className="kpi-card">
                                        <span className="kpi-value">847</span>
                                        <span className="kpi-label">Alunos Ativos</span>
                                    </div>
                                </div>
                                <div className="dash-chart">
                                    <div className="chart-title">Frequência Diária</div>
                                    <div className="chart-bars">
                                        <div className="chart-bar" style={{ '--height': '85%' } as React.CSSProperties}><span>Seg</span></div>
                                        <div className="chart-bar" style={{ '--height': '92%' } as React.CSSProperties}><span>Ter</span></div>
                                        <div className="chart-bar" style={{ '--height': '88%' } as React.CSSProperties}><span>Qua</span></div>
                                        <div className="chart-bar" style={{ '--height': '95%' } as React.CSSProperties}><span>Qui</span></div>
                                        <div className="chart-bar" style={{ '--height': '78%' } as React.CSSProperties}><span>Sex</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feature-info">
                        <div className="feature-tag">Pilar 4</div>
                        <h3>Inteligência Educacional</h3>
                        <p>Dashboards estratégicos transformam dados brutos em insights poderosos. 
                        Gestores e secretarias identificam padrões de faltas, riscos de evasão e 
                        podem agir preventivamente com políticas baseadas em evidências.</p>
                        <ul className="feature-list">
                            <li><i data-lucide="check"></i> Painéis de dados em tempo real</li>
                            <li><i data-lucide="check"></i> Identificação precoce de risco de evasão</li>
                            <li><i data-lucide="check"></i> Indicadores educacionais completos</li>
                            <li><i data-lucide="check"></i> IA preditiva para ações preventivas</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

    
    
    
    <section className="section section-benefits" id="impacto">
        <div className="container">
            <div className="section-header" data-animate="fade-up">
                <span className="section-tag">Impacto Social</span>
                <h2 className="section-title">Um ecossistema onde <em>todos ganham</em></h2>
            </div>
            <div className="benefits-grid">
                <div className="benefit-card" data-animate="fade-up" data-delay="100">
                    <div className="benefit-icon benefit-icon-family">
                        <i data-lucide="home"></i>
                    </div>
                    <h3>Para as Famílias</h3>
                    <ul>
                        <li>Segurança absoluta e paz mental</li>
                        <li>Comunicação direta e sem ruídos</li>
                        <li>Acompanhamento pedagógico em tempo real</li>
                        <li>Participação ativa na educação dos filhos</li>
                    </ul>
                </div>
                <div className="benefit-card benefit-card-featured" data-animate="fade-up" data-delay="200">
                    <div className="benefit-icon benefit-icon-school">
                        <i data-lucide="school"></i>
                    </div>
                    <h3>Para as Escolas</h3>
                    <ul>
                        <li>Automação extrema e redução de burocracia</li>
                        <li>Organização eficiente da gestão</li>
                        <li>Canal oficial e profissional de comunicação</li>
                        <li>Valorização do corpo docente</li>
                    </ul>
                </div>
                <div className="benefit-card" data-animate="fade-up" data-delay="300">
                    <div className="benefit-icon benefit-icon-gov">
                        <i data-lucide="landmark"></i>
                    </div>
                    <h3>Para a Sociedade</h3>
                    <ul>
                        <li>Modernização do ensino público</li>
                        <li>Combate ativo à evasão escolar com dados</li>
                        <li>Eficiência na aplicação de políticas educacionais</li>
                        <li>Retorno social de R$ 4,94 para cada R$ 1,00 investido</li>
                    </ul>
                </div>
            </div>

            
            <div className="impact-counter" data-animate="fade-up">
                <div className="impact-item">
                    <div className="impact-icon"><i data-lucide="school"></i></div>
                    <div className="impact-number" data-count="1200">0</div>
                    <div className="impact-label">Alunos por escola em média</div>
                </div>
                <div className="impact-item">
                    <div className="impact-icon"><i data-lucide="users"></i></div>
                    <div className="impact-number" data-count="3000">0</div>
                    <div className="impact-label">Pessoas impactadas por escola</div>
                </div>
                <div className="impact-item">
                    <div className="impact-icon"><i data-lucide="map-pin"></i></div>
                    <div className="impact-number" data-count="100">0</div>
                    <div className="impact-label">Escolas no projeto piloto</div>
                </div>
                <div className="impact-item">
                    <div className="impact-icon"><i data-lucide="trending-up"></i></div>
                    <div className="impact-number" data-count="300" data-suffix="k+">0</div>
                    <div className="impact-label">Cidadãos beneficiados</div>
                </div>
            </div>
        </div>
    </section>

    
    <section className="section section-future">
        <div className="container">
            <div className="future-card" data-animate="fade-up">
                <div className="future-visual">
                    <div className="ai-brain">
                        <i data-lucide="brain-circuit"></i>
                    </div>
                    <div className="ai-particles"></div>
                </div>
                <div className="future-content">
                    <span className="section-tag tag-light">O Futuro</span>
                    <h2>A Era da IA na Educação</h2>
                    <p>
                        A plataforma não apenas resolve os problemas de hoje, mas prepara a 
                        educação para o amanhã. Com inteligência artificial integrada:
                    </p>
                    <div className="future-features">
                        <div className="future-feature">
                            <i data-lucide="scan-search"></i>
                            <span>Identificação antecipada de alunos em risco de evasão</span>
                        </div>
                        <div className="future-feature">
                            <i data-lucide="lightbulb"></i>
                            <span>Sugestão automatizada de intervenções pedagógicas</span>
                        </div>
                        <div className="future-feature">
                            <i data-lucide="library"></i>
                            <span>Ecossistemas com bibliotecas e conteúdos digitais</span>
                        </div>
                        <div className="future-feature">
                            <i data-lucide="target"></i>
                            <span>Ações pedagógicas personalizadas por aluno</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    
    
    
    <section className="section section-cta" id="contato">
        <div className="container">
            <div className="cta-grid" data-animate="fade-up">
                <div className="cta-info">
                    <h2>O Futuro da Educação Começa<br /><em>com a Sua Decisão</em></h2>
                    <p className="cta-quote">
                        "Crianças seguras, famílias conectadas e escolas modernas são os pilares 
                        de uma comunidade mais forte."
                    </p>
                    <p className="cta-description">
                        Junte-se a nós nesta missão. Invista na segurança e na educação das nossas 
                        crianças e construa um legado inesquecível de inovação e cidadania.
                    </p>
                    <div style={{ marginTop: '24px' }}>
                        <a href="#hero" className="btn btn-outline-light btn-lg" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                            <i data-lucide="arrow-up"></i>
                            <span>Voltar ao Topo</span>
                        </a>
                    </div>
                </div>

                <div className="contact-form-container">
                    <h3>Fale Conosco</h3>
                        <form onSubmit={handleFormSubmit} className="contact-form">
                            <div className="form-group">
                                <label htmlFor="nome" className="form-label">Nome Completo</label>
                                <input type="text" id="nome" value={nome} onChange={(e) => setNome(e.target.value)} className="form-input" placeholder="Seu nome completo" required />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="email" className="form-label">E-mail</label>
                                <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" placeholder="seu.email@exemplo.com" required />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="assunto" className="form-label">Assunto</label>
                                <input type="text" id="assunto" value={assunto} onChange={(e) => setAssunto(e.target.value)} className="form-input" placeholder="Qual o assunto do contato?" required />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="mensagem" className="form-label">Mensagem</label>
                                <textarea id="mensagem" value={mensagem} onChange={(e) => setMensagem(e.target.value)} className="form-textarea" placeholder="Escreva sua mensagem aqui..." rows={4} required></textarea>
                            </div>

                            {/* Honeypot field (hidden from users, bot trap) */}
                            <div className="form-group-honey" style={{ display: 'none' }}>
                                <label htmlFor="website_url">Website URL</label>
                                <input type="text" id="website_url" value={websiteUrl} onChange={(e) => setWebsiteUrl(e.target.value)} autoComplete="off" />
                            </div>
                            
                            <div className="form-group">
                                <label className="form-label">Validação Humana</label>
                                <div className="captcha-wrapper">
                                    <span className="captcha-question">Quanto é {numA} + {numB}?</span>
                                    <input
                                      inputMode="numeric"
                                      pattern="[0-9]*"
                                      maxLength={3}
                                      value={captchaAnswer}
                                      onChange={(e) => setCaptchaAnswer(e.target.value.replace(/\D/g, ''))}
                                      className="form-input captcha-input"
                                      placeholder="?"
                                      required
                                    />
                                </div>
                            </div>
                            
                            <button type="submit" disabled={submitting} className="btn btn-primary btn-submit">
                                {submitting ? 'Enviando...' : 'Enviar Mensagem'}
                            </button>
                        </form>
                </div>
            </div>
        </div>
    </section>

    
    
    
    <footer className="footer">
        <div className="container">
            <div className="footer-grid">
                <div className="footer-brand">
                    <div className="footer-logo">
                        <AcShieldLogo style={{ width: 24, height: 24, marginRight: 8 }} />
                        <span>Aluno <strong>Conectado</strong></span>
                    </div>
                    <p>Uma plataforma digital para reconectar escolas, famílias e alunos, transformando a gestão educacional.</p>
                </div>
                <div className="footer-links">
                    <h4>Institucional</h4>
                    <ul>
                        <li><Link to="/sobre">Sobre a Empresa & Projeto</Link></li>
                        <li><Link to="/politica-de-privacidade">Política de Privacidade</Link></li>
                        <li><Link to="/cancelar-email">Cancelar Recebimento (Opt-Out)</Link></li>
                        <li><a href="#pilares">Os 6 Pilares</a></li>
                        <li><a href="#funcionalidades">Funcionalidades</a></li>
                        <li><a href="#impacto">Impacto Social</a></li>
                    </ul>
                </div>
                <div className="footer-links">
                    <h4>Programa</h4>
                    <ul>
                        <li><a href="#">Segurança Escolar</a></li>
                        <li><a href="#">Comunicação Digital</a></li>
                        <li><a href="#">Gestão Integrada</a></li>
                        <li><a href="#">Inteligência Educacional</a></li>
                        <li><a href="#">Apoio Social</a></li>
                    </ul>
                </div>
                <div className="footer-contact">
                    <h4>Contato</h4>
                    <ul>
                        <li><i data-lucide="mail"></i> contato@alunoconectado.com.br</li>
                        <li><i data-lucide="phone"></i> (31) 3274-9340</li>
                        <li><i data-lucide="map-pin"></i> Avenida Portugal, 4340, Sala 101, Jardim Atlântico<br />Belo Horizonte - MG, CEP 31710-434</li>
                    </ul>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; 2026 Aluno Conectado. Todos os direitos reservados.</p>
            </div>
        </div>
    </footer>

    

    </div>
  );
}
